import { gql } from '@apollo/client';

export const READ_SALES_ORDER_STATUS = gql`
  query ReadSalesOrderStatus($salesOrderId: String!) {
    readSalesOrder(salesOrderId: $salesOrderId) {
      uid
      orderStatus
      paymentState
      orderLines {
        orderLineId
        version
        salesOrderId
        salesOrderStatus
        status
        charge {
          validity {
            validFrom
            validTo
          }
        }
      }
    }
  }
`;
